<dx-text-box [(value)]="value" name="message" (onEnterKey)="send()" maxLength="256"></dx-text-box>
<dx-button (onClick)="send()" [text]="'nidaRed.workplace.send' | transloco" stylingMode="contained" type="normal"> </dx-button>
